<template>
  <!--begin::Header-->
  <div id="kt_header" style="" class="header align-items-stretch">
    <!--begin::Container-->
    <div
      :class="{
        'container-fluid': headerWidthFluid,
        'container-xxl': !headerWidthFluid,
      }"
      class="d-flex align-items-stretch justify-content-between"
    >
      <!--begin::Aside mobile toggle-->
      <div
        class="d-flex align-items-center d-lg-none ms-n3 me-1"
        title="Show aside menu"
      >
        <div
          class="btn btn-icon btn-active-light-primary"
          id="kt_aside_mobile_toggle"
        >
          <span class="svg-icon svg-icon-2x mt-1">
            <inline-svg src="/media/icons/duotune/abstract/abs015.svg" />
          </span>
        </div>
      </div>
      <!--end::Aside mobile toggle-->

      <!--begin::Mobile logo-->
      <div class="d-flex align-items-center flex-grow-1 flex-lg-grow-0">
        <a href="#" class="d-lg-none">
          <!-- <img alt="Logo" src="/media/logos/logo-2s.png" class="h-30px" /> -->
          <h1 class="d-flex align-items-center text-dark fw-bolder my-1 fs-3">
          {{ title }}
        </h1>
        </a>
      </div>
      <!--end::Mobile logo-->

      <!--begin::Wrapper-->
      <div
        class="
          d-flex
          align-items-stretch
          justify-content-between
          flex-lg-grow-1
        "
      >
        <!--begin::Navbar-->
        <div class="d-flex align-items-stretch" id="kt_header_menu_nav">
          
          <div
            name="partnerName"
            class="align-items-center d-flex " 
            v-if="representPartner && representPartner.trim() != ''">
            <partner-select></partner-select>
            <!-- <h1 class="d-flex align-items-center text-dark fw-bolder my-1 fs-3">
              {{representPartner.partnerName}} asasd

            </h1> -->
            <span
              class="h-20px border-gray-200 border-start mx-4"
            ></span>
          </div>
          <KTMenu :breadcrumbs="breadcrumbs" :title="title"></KTMenu>
        </div>
        <!--end::Navbar-->

        <!--begin::Topbar-->
        <div class="d-flex align-items-stretch flex-shrink-0">
          <KTTopbar></KTTopbar>
        </div>
        <!--end::Topbar-->
      </div>
      <!--end::Wrapper-->
    </div>
    <!--end::Container-->
  </div>
  <!--end::Header-->
</template>

<script lang="ts">
import { defineComponent, computed } from "vue";
import KTTopbar from "@/layout/header/Topbar.vue";
import KTMenu from "@/layout/header/Menu.vue";
import { useStore } from "vuex";
import PartnerSelect from "../PartnerSelect.vue"

import {
  headerWidthFluid,
  headerLeft,
  asideDisplay,
} from "@/core/helpers/config";

export default defineComponent({
  name: "KTHeader",
  props: {
    breadcrumbs: Array,
    title: String,
  },
  components: {
    KTTopbar,
    KTMenu,
    PartnerSelect
  },
  setup() {
    const store = useStore();

    const representPartner = computed(() => store.getters.getRepresentId)


    return {
      headerWidthFluid,
      headerLeft,
      asideDisplay,
      representPartner
    };
  },
});
</script>
